<script setup>
import DataTableLayout from '@js/components/tables/DataTableLayout.vue';
import HeaderCell from '@js/components/tables/cells/HeaderCell.vue';
import NumberCell from '@js/components/tables/cells/NumberCell.vue';
import PillCell from '@js/components/tables/cells/PillCell.vue';
import StatusCell from '@js/components/tables/cells/StatusCell.vue';
import TextCell from '@js/components/tables/cells/TextCell.vue';
import { useDataTable } from '@js/utils/dataTable';
import { useRoute } from '@js/utils/route';
import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue';

const { tenant, promoPriceRule } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    promoPriceRule: {
        type: Object,
        required: true,
    },
});

const { route } = useRoute();

const columnHelper = createColumnHelper();

const {
    loading,
    table,
    count,
    globalFilter,
    filters,
    availableFilters,
    setGlobalFilter,
    setFilters,
} = useDataTable({
    columns: [
        columnHelper.accessor(() => null, {
            id: 'code',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: 'Code',
                }),
            cell: (props) =>
                h(PillCell, {
                    pillValue: props.row.original.code,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'sendStart',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: "Début d'envoi",
                }),
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.sendStart,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'sendEnd',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: "Fin d'envoi",
                }),
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.sendEnd,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'expiresAt',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: 'Expiration',
                }),
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.expiresAt,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'cmsCartPriceRuleId',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: 'ID règle CMS',
                }),
            cell: (props) =>
                props.row.original.cmsCartPriceRuleId !== null
                    ? h(NumberCell, {
                          number: props.row.original.cmsCartPriceRuleId,
                      })
                    : null,
        }),
        columnHelper.accessor(() => null, {
            id: 'createdOnCms',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: 'Poussé au CMS',
                }),
            cell: (props) =>
                h(StatusCell, {
                    status: props.row.original.createdOnCms,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'createdAt',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: 'Généré le',
                }),
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.createdAt,
                }),
        }),
    ],
    url: route(
        'front.projectManagement.modules.postEmailingAutomationPromoPriceRuleCodes',
        {
            tenant: tenant.id,
            promoPriceRule: promoPriceRule.id,
        },
    ),
});
</script>

<template>
    <DataTableLayout
        :table="table"
        :count="count"
        :global-filter="globalFilter"
        :filters="filters"
        :available-filters="availableFilters"
        :set-filters="setFilters"
        :set-global-filter="setGlobalFilter"
        :loading="loading"
    />
</template>
